import moment from 'moment'
import {
  CitySortRatio,
  PeriodFilter,
  SortRatio,
  StreetSortRatio,
  TopWaste,
  AllWaste,
  UnsortableWaste,
  WasteCollectionRoute,
  WasteCard,
  WasteCollectionRouteOverview,
  WasteCollectionSchedule,
  WasteCollectionScheduleOverview,
  WasteCollectionYard,
  WasteEvidenceOverview,
  WasteEvidence,
  WasteEvidences,
  PaginationQueryParams,
  WasteLimit,
  WasteCollectionYardVisit,
  WasteCollectionYardVisits,
  FeePayer,
  Subject,
  TrashBin,
  TrashBins,
  WasteCompanyInfo,
} from '~/types/types'

interface DemoSubjectStore {
  fetchTopWastes: () => void
  fetchAllWastes: () => void
  fetchSortRatio: () => void
  fetchCitySortRatio: () => void
  fetchStreetSortRatio: () => void
  fetchWasteCard: () => void
  fetchWasteCards: () => void
  fetchWasteCollectionYard: () => void
  fetchWasteEvidenceOverview: () => void
  fetchWasteCollectionScheduleOverview: () => void
  fetchWasteCollectionRouteOverview: () => void
  fetchWasteCompanyInfo: () => void
  toggleWasteCollectionRouteNotification: () => void
  submitSuggestion: () => void
  fetchWasteEvidences: () => void
  fetchWasteCollectionRoute: () => void
  fetchWasteCollectionSchedule: () => void
  fetchWasteLimit: () => void
  fetchTopWasteCollectionYardVisits: () => void
  fetchWasteCollectionYardVisits: () => void
  fetchSubject: () => void
  fetchFeePayers: () => void
  fetchTopTrashBins: () => void
  updateFeePayer: () => void
  fetchTrashBins: () => void
  unsortableWaste: UnsortableWaste
  topWastes: TopWaste[]
  allWastes: AllWaste[]
  sortRatio: SortRatio
  citySortRatio: CitySortRatio
  streetSortRatio: StreetSortRatio
  wasteCard: WasteCard
  wasteCollectionYard: WasteCollectionYard
  wasteEvidenceOverview: WasteEvidenceOverview[]
  wasteCollectionScheduleOverview: WasteCollectionScheduleOverview[]
  wasteCollectionRouteOverview: WasteCollectionRouteOverview[]
  wasteCompanyInfo: WasteCompanyInfo
  wasteEvidences: WasteEvidences
  wasteCollectionRoute: WasteCollectionRoute[]
  wasteCollectionSchedule: WasteCollectionSchedule[]
  wasteLimit: WasteLimit[]
  topWasteCollectionYardVisits: WasteCollectionYardVisit[]
  wasteCollectionYardVisits: WasteCollectionYardVisits
  subject: Subject
  feePayers: FeePayer[]
  topTrashBins: TrashBin[]
  trashBins: TrashBins
}

export default (): DemoSubjectStore => {
  return {
    fetchTopWastes: () => {},
    fetchAllWastes: () => {},
    fetchSortRatio: () => {},
    fetchCitySortRatio: () => {},
    fetchStreetSortRatio: () => {},
    fetchWasteCard: () => {},
    fetchWasteCards: () => {},
    fetchWasteCollectionYard: () => {},
    fetchWasteEvidenceOverview: () => {},
    fetchWasteCollectionScheduleOverview: () => {},
    fetchWasteCollectionRouteOverview: () => {},
    fetchWasteCompanyInfo: () => {},
    toggleWasteCollectionRouteNotification: () => {},
    submitSuggestion: () => {},
    fetchWasteEvidences: () => {},
    fetchWasteCollectionRoute: () => {},
    fetchWasteCollectionSchedule: () => {},
    fetchWasteLimit: () => {},
    fetchTopWasteCollectionYardVisits: () => {},
    fetchWasteCollectionYardVisits: () => {},
    fetchSubject: () => {},
    fetchFeePayers: () => {},
    fetchTopTrashBins: () => {},
    updateFeePayer: () => {},
    fetchTrashBins: () => {},
    unsortableWaste: {
      weight: 9357.92,
      trend: -12.53,
    },
    topWastes: {
      topUnsortableWastes: [
        {
          isWasteCollectionYardWaste: true,
          wasteCode: '20 03 01',
          wasteName: 'ZKO',
          wasteColor: '#191919',
          weight: 50,
          volume: null,
          previousWeight: null,
          previousVolume: null,
          trend: null,
        },
        {
          isWasteCollectionYardWaste: false,
          wasteCode: '15 01 02',
          wasteName: 'Plastové obaly',
          wasteColor: '',
          weight: 17,
          volume: 1580,
          previousWeight: 10.36,
          previousVolume: 1220,
          trend: 0.651544401544402,
        },
      ],
      topSortableWastes: [
        {
          isWasteCollectionYardWaste: false,
          wasteCode: '20 01 02',
          wasteName: 'Sklo',
          wasteColor: '#2E7811',
          weight: 10,
          volume: 10,
          previousWeight: 2813.07,
          previousVolume: 29280,
          trend: -0.088988187282933,
        },
        {
          isWasteCollectionYardWaste: false,
          wasteCode: '20 02 01',
          wasteName: 'BRO',
          wasteColor: '#C36E27',
          weight: 20,
          volume: 20,
          previousWeight: 3.7,
          previousVolume: 120,
          trend: 4.41081081081081,
        },
      ],
    },
    allWastes: [
      {
        code: '20 03 01',
        name: 'Sko',
        color: '#191919',
        weight: 1935717.92,
        previousWeight: null,
        trend: -5.84,
      },
      {
        code: '20 01 39',
        name: 'Plasty',
        color: '#FFFF31',
        weight: 64985.99,
        previousWeight: null,
        trend: 6.32,
      },
      {
        code: '20 01 02',
        name: 'Sklo',
        color: '#2E7811',
        weight: 5042.2,
        previousWeight: null,
        trend: 10.48,
      },
      {
        code: '20 01 01',
        name: 'Papír a lepenka',
        color: '#008FF8',
        weight: 2156.6,
        previousWeight: null,
        trend: 3.51,
      },
      {
        code: '17 09 04',
        name: 'Stavební odpad',
        color: '#000000',
        weight: 555,
        previousWeight: null,
        trend: 6.73,
      },
    ],
    sortRatio: {
      municipality: 'Ostrava',
      otherSubjectsPercentil: 90,
      otherWasteWeight: 22555,
      unsortableWasteWeight: 125717.92,
      sortRatio: 60,
      trend: 8.24,
      topWastes: [
        {
          color: '#FFFF31',
          name: 'Plasty',
          weight: 4985.99,
        },
        {
          color: '#2E7811',
          name: 'Sklo',
          weight: 50042.2,
        },
        {
          color: '#008FF8',
          name: 'Papír a lepenka',
          weight: 62156.6,
        },
      ],
    },
    citySortRatio: {
      city: 'Ostrava',
      street: 'Ostravská',
      currentSortRatio: 75,
      trend: 2.52,
      topSortableWastes: [
        {
          wasteCode: '20 01 01',
          wasteColor: '#008FF8',
          wasteName: 'Papír a lepenka',
          weight: 400,
          volume: 400,
        },
        {
          wasteCode: '20 01 02',
          wasteColor: '#2E7811',
          wasteName: 'Sklo',
          weight: 320,
          volume: 320,
        },
        {
          wasteCode: '20 01 39',
          wasteColor: '#FFFF31',
          wasteName: 'Plasty',
          weight: 225,
          volume: 225,
        },
      ],
      topUnsortableWastes: [
        {
          isWasteCollectionYardWaste: false,
          isSortable: false,
          wasteCode: '20 03 01',
          wasteColor: '#191919',
          wasteName: 'ZKO',
          weight: 2000,
          volume: 2000,
        },
      ],
    },
    streetSortRatio: {
      city: 'Ostrava',
      street: 'Ostravská',
      currentSortRatio: 66,
      trend: 5,
      topSortableWastes: [
        {
          wasteCode: '20 01 01',
          wasteColor: '#008FF8',
          wasteName: 'Papír a lepenka',
          weight: 200,
          volume: 200,
        },
        {
          wasteCode: '20 01 02',
          wasteColor: '#2E7811',
          wasteName: 'Sklo',
          weight: 120,
          volume: 120,
        },
        {
          wasteCode: '20 01 39',
          wasteColor: '#FFFF31',
          wasteName: 'Plasty',
          weight: 80,
          volume: 80,
        },
      ],
      topUnsortableWastes: [
        {
          isWasteCollectionYardWaste: false,
          isSortable: false,
          wasteCode: '20 03 01',
          wasteColor: '#191919',
          wasteName: 'ZKO',
          weight: 600,
          volume: 600,
        },
      ],
    },
    wasteCard: {
      id: 1,
      code: 'H0001.000000',
      plainCode: '010230',
      feePayerName: 'John Doe',
      state: 'Assigned',
      validFrom: moment().subtract(1, 'year'),
      validTo: null,
    },
    wasteCollectionYard: {
      id: 1,
      name: 'Sběrný dvůr 1',
      streetAddress: 'Ostravská 700 30, Ostrava',
      location: {
        latitude: 49.8339461,
        longitude: 18.2487258,
      },
      openingSchedule: [
        {
          dayOfWeek: 'Monday',
          openingHours: [{timeOpen: '09:00', timeClose: '17:00'}],
          description: '',
        },
        {
          dayOfWeek: 'Tuesday',
          openingHours: [{timeOpen: '09:00', timeClose: '17:00'}],
          description: '',
        },
        {
          dayOfWeek: 'Wednesday',
          openingHours: [{timeOpen: '09:00', timeClose: '17:00'}],
          description: '',
        },
        {
          dayOfWeek: 'Thursday',
          openingHours: [{timeOpen: '09:00', timeClose: '17:00'}],
          description: '',
        },
        {
          dayOfWeek: 'Friday',
          openingHours: [{timeOpen: '09:00', timeClose: '17:00'}],
          description: '',
        },
        {
          dayOfWeek: 'Saturday',
          openingHours: [{timeOpen: '09:00', timeClose: '17:00'}],
          description: '',
        },
        {
          dayOfWeek: 'Sunday',
          openingHours: [{timeOpen: '09:00', timeClose: '17:00'}],
          description: '',
        },
      ],
    },
    wasteEvidenceOverview: [
      {
        id: 6905833,
        binName: 'Kontejner papír',
        approximationCoefficient: 0,
        wasteColor: '#008FF8',
        weight: 7.133,
        state: true,
        processedAt: moment('2024-01-19T08:38:05.11'),
      },
      {
        id: 6905831,
        binName: 'Kontejner papír',
        approximationCoefficient: 0,
        wasteColor: '#008FF8',
        weight: 21.4,
        state: true,
        processedAt: moment('2024-01-18T15:31:56.403'),
      },
      {
        id: 6905827,
        binName: 'Popelnice SKO',
        approximationCoefficient: 0,
        wasteColor: '#191919',
        weight: 29.27,
        state: true,
        processedAt: moment('2024-01-10T00:00:00'),
      },
      {
        id: 6904688,
        binName: 'Kontejner PET',
        approximationCoefficient: 0,
        wasteColor: '#FFFF31',
        weight: 1.5,
        state: true,
        processedAt: moment('2023-10-18T14:10:33.873'),
      },
      {
        id: 6904687,
        binName: 'Kontejner papír',
        approximationCoefficient: 0,
        wasteColor: '#008FF8',
        weight: 2.266,
        state: true,
        processedAt: moment('2023-10-18T12:43:38.527'),
      },
    ],
    wasteCollectionScheduleOverview: [
      {
        id: 96,
        wasteName: 'Bio',
        wasteColor: '#C36E27',
        collectionDate: moment('2024-02-06T00:00:00'),
      },
      {
        id: 96,
        wasteName: 'Bio',
        wasteColor: '#C36E27',
        collectionDate: moment('2024-03-05T00:00:00'),
      },
      {
        id: 2,
        wasteName: 'Plasty',
        wasteColor: '#FFFF31',
        collectionDate: moment('2024-03-06T00:00:00'),
      },
      {
        id: 96,
        wasteName: 'Bio',
        wasteColor: '#C36E27',
        collectionDate: moment('2024-04-09T00:00:00'),
      },
      {
        id: 96,
        wasteName: 'Bio',
        wasteColor: '#C36E27',
        collectionDate: moment('2024-05-07T00:00:00'),
      },
    ],
    wasteCollectionRouteOverview: [
      {
        id: 2,
        wasteName: 'Plasty',
        wasteColor: '#FFFF31',
        collectionDayOfWeek: 'Wednesday',
        collectionRecurrenceUnit: 'Months',
        collectionRecurrenceValue: 2,
        nextCollectionDate: moment('2024-03-06T00:00:00'),
        isNotificationEnabled: false,
      },
      {
        id: 96,
        wasteName: 'Bio',
        wasteColor: '#C36E27',
        collectionDayOfWeek: 'Tuesday',
        collectionRecurrenceUnit: 'Months',
        collectionRecurrenceValue: 1,
        nextCollectionDate: moment('2024-02-06T00:00:00'),
        isNotificationEnabled: false,
      },
    ],
    wasteCompanyInfo: {
      id: 1,
      name: 'Ostrava',
      logoUrl: 'images/5/logo.png',
    },
    wasteEvidences: {
      items: [
        {
          id: 6905833,
          processedTs: moment('2024-01-19T08:38:05.11'),
          wasteColor: '#008FF8',
          binName: 'Kontejner papír',
          weight: 7.133,
          approximationCoefficient: 0,
          state: true,
        },
        {
          id: 6905831,
          processedTs: moment('2024-01-18T15:31:56.403'),
          wasteColor: '#008FF8',
          binName: 'Kontejner papír',
          weight: 21.4,
          approximationCoefficient: 0,
          state: true,
        },
        {
          id: 6905827,
          processedTs: moment('2024-01-10T00:00:00'),
          wasteColor: '#191919',
          binName: 'Popelnice SKO',
          weight: 29.27,
          approximationCoefficient: 0,
          state: true,
        },
        {
          id: 6904688,
          processedTs: moment('2023-10-18T14:10:33.873'),
          wasteColor: '#FFFF31',
          binName: 'Kontejner PET',
          weight: 1.5,
          approximationCoefficient: 0,
          state: true,
        },
        {
          id: 6904687,
          processedTs: moment('2023-10-18T12:43:38.527'),
          wasteColor: '#008FF8',
          binName: 'Kontejner papír',
          weight: 2.266,
          approximationCoefficient: 0,
          state: true,
        },
        {
          id: 6904686,
          processedTs: moment('2023-10-18T12:43:29.813'),
          wasteColor: '#FFFF31',
          binName: 'Kontejner PET',
          weight: 1,
          approximationCoefficient: 0,
          state: true,
        },
        {
          id: 6904678,
          processedTs: moment('2023-10-09T14:29:31.92'),
          wasteColor: '#FFFF31',
          binName: 'Kontejner PET',
          weight: 1513.333,
          approximationCoefficient: 0,
          state: true,
        },
        {
          id: 6904677,
          processedTs: moment('2023-10-09T14:25:54.673'),
          wasteColor: '#008FF8',
          binName: 'Kontejner papír',
          weight: 6,
          approximationCoefficient: 0,
          state: true,
        },
        {
          id: 6904676,
          processedTs: moment('2023-10-09T14:25:41.77'),
          wasteColor: '#FFFF31',
          binName: 'Kontejner PET',
          weight: 3.333,
          approximationCoefficient: 0,
          state: true,
        },
        {
          id: 6904675,
          processedTs: moment('2023-10-09T14:25:41.77'),
          wasteColor: '#2E7811',
          binName: 'Kontejner sklo bílé',
          weight: 6,
          approximationCoefficient: 0,
          state: true,
        },
      ],
      pagination: {
        page: 1,
        pageCount: 1,
        limit: 10,
        total: 10,
      },
    },
    wasteCollectionRoute: [
      {
        id: 2,
        wasteName: 'Plasty',
        wasteColor: '#FFFF31',
        collectionDayOfWeek: 'Wednesday',
        collectionRecurrenceUnit: 'Months',
        collectionRecurrenceValue: 2,
        nextCollectionDate: moment('2024-03-06T00:00:00'),
        isNotificationEnabled: false,
      },
      {
        id: 96,
        wasteName: 'Bio',
        wasteColor: '#C36E27',
        collectionDayOfWeek: 'Tuesday',
        collectionRecurrenceUnit: 'Months',
        collectionRecurrenceValue: 1,
        nextCollectionDate: moment('2024-02-06T00:00:00'),
        isNotificationEnabled: false,
      },
    ],
    wasteCollectionSchedule: [
      {
        id: 2,
        wasteName: 'Plasty',
        wasteColor: '#FFFF31',
        collectionDate: moment('2025-01-08T00:00:00'),
      },
      {
        id: 96,
        wasteName: 'Bio',
        wasteColor: '#C36E27',
        collectionDate: moment('2025-01-07T00:00:00'),
      },
      {
        id: 96,
        wasteName: 'Bio',
        wasteColor: '#C36E27',
        collectionDate: moment('2024-12-03T00:00:00'),
      },
      {
        id: 2,
        wasteName: 'Plasty',
        wasteColor: '#FFFF31',
        collectionDate: moment('2024-11-06T00:00:00'),
      },
      {
        id: 96,
        wasteName: 'Bio',
        wasteColor: '#C36E27',
        collectionDate: moment('2024-11-05T00:00:00'),
      },
      {
        id: 96,
        wasteName: 'Bio',
        wasteColor: '#C36E27',
        collectionDate: moment('2024-10-08T00:00:00'),
      },
      {
        id: 2,
        wasteName: 'Plasty',
        wasteColor: '#FFFF31',
        collectionDate: moment('2024-09-04T00:00:00'),
      },
      {
        id: 96,
        wasteName: 'Bio',
        wasteColor: '#C36E27',
        collectionDate: moment('2024-09-03T00:00:00'),
      },
      {
        id: 96,
        wasteName: 'Bio',
        wasteColor: '#C36E27',
        collectionDate: moment('2024-08-06T00:00:00'),
      },
      {
        id: 2,
        wasteName: 'Plasty',
        wasteColor: '#FFFF31',
        collectionDate: moment('2024-07-10T00:00:00'),
      },
    ],
    wasteLimit: [
      {
        wasteId: 1,
        wasteName: 'Sklo',
        wasteColor: '#2E7811',
        wasteLimit: 6000,
        used: 5010,
        usedPercentage: 83.5,
        remaining: 990,
      },
      {
        wasteId: 2,
        wasteName: 'Papír a lepenka',
        wasteColor: '#008FF8',
        wasteLimit: 5,
        used: 1034.553,
        usedPercentage: 20691.06,
        remaining: -1029.553,
      },
      {
        wasteId: 3,
        wasteName: 'Plasty',
        wasteColor: '#FFFF31',
        wasteLimit: 2000,
        used: 1034,
        usedPercentage: 51.7,
        remaining: 966,
      },
    ],
    topWasteCollectionYardVisits: [
      {
        id: 1,
        invoice: 'V2401180',
        fee: 8.47,
        feePaid: false,
        startReportTs: moment('2024-01-18T15:31:48.293'),
        endReportTs: moment('2024-01-18T15:32:15.697'),
        feePayerName: 'Nela Soukupová',
        feePayerWasteCardCode: '123',
        wasteName: 'Papír a lepenka',
        wasteColor: '#008FF8',
        weight: 20,
        recordCount: 1,
        subRecords: null,
      },
      {
        id: 2,
        invoice: 'V2310180',
        fee: 20.53,
        feePaid: true,
        startReportTs: moment('2023-10-18T14:08:18.017'),
        endReportTs: moment('2023-10-18T14:10:41.327'),
        feePayerName: 'Nela Soukupová',
        feePayerWasteCardCode: '123',
        wasteName: 'Plasty',
        wasteColor: '#FFFF31',
        weight: 53,
        recordCount: 1,
        subRecords: null,
      },
      {
        id: 3,
        invoice: 'V2310030',
        fee: null,
        feePaid: true,
        startReportTs: moment('2023-09-01T09:06:02.017'),
        endReportTs: moment('2023-09-01T10:06:02.017'),
        feePayerName: 'Nela Soukupová',
        feePayerWasteCardCode: '123',
        wasteName: '',
        wasteColor: '#000000',
        weight: null,
        recordCount: 0,
        subRecords: null,
      },
      {
        id: 4,
        invoice: 'V2308160',
        fee: 0,
        feePaid: true,
        startReportTs: moment('2023-08-16T05:43:03.223'),
        endReportTs: moment('2023-08-16T05:43:03.223'),
        feePayerName: 'Nela Soukupová',
        feePayerWasteCardCode: '123',
        wasteName: '',
        wasteColor: '#000000',
        weight: 0,
        recordCount: 3,
        subRecords: [
          {
            startReportTs: moment('2023-08-16T07:44:24.713'),
            wasteName: 'Plasty',
            wasteColor: '#FFFF31',
            weight: 30,
            fee: 15.28,
          },
          {
            startReportTs: moment('2023-08-16T07:44:24.75'),
            wasteName: 'Papír a lepenka',
            wasteColor: '#008FF8',
            weight: 68,
            fee: 53.24,
          },
          {
            startReportTs: moment('2023-08-16T07:44:24.75'),
            wasteName: 'Sklo',
            wasteColor: '#2E7811',
            weight: 73,
            fee: 78.31,
          },
        ],
      },
      {
        id: 5,
        invoice: '22080300',
        fee: 21.17,
        feePaid: true,
        startReportTs: moment('2022-08-03T10:43:40.097'),
        endReportTs: moment('2022-08-03T10:43:40.097'),
        feePayerName: 'Nela Soukupová',
        feePayerWasteCardCode: '123',
        wasteName: 'Papír a lepenka',
        wasteColor: '#008FF8',
        weight: 50,
        recordCount: 1,
        subRecords: null,
      },
    ],
    wasteCollectionYardVisits: {
      items: [
        {
          id: 1,
          invoice: 'V240118001',
          fee: 8.47,
          feePaid: false,
          startReportTs: moment('2024-01-18T15:31:48.293'),
          endReportTs: moment('2024-01-18T15:32:15.697'),
          feePayerName: 'Nela Soukupová',
          feePayerWasteCardCode: '123',
          wasteName: 'Papír a lepenka',
          wasteColor: '#008FF8',
          weight: 0,
          recordCount: 1,
          subRecords: null,
        },
        {
          id: 2,
          invoice: 'V231018001',
          fee: 0,
          feePaid: true,
          startReportTs: moment('2023-10-18T14:08:18.017'),
          endReportTs: moment('2023-10-18T14:10:41.327'),
          feePayerName: 'Nela Soukupová',
          feePayerWasteCardCode: '123',
          wasteName: 'Plasty',
          wasteColor: '#FFFF31',
          weight: 0,
          recordCount: 1,
          subRecords: null,
        },
        {
          id: 3,
          invoice: 'V231003001',
          fee: null,
          feePaid: true,
          startReportTs: moment('2023-09-01T09:06:02.017'),
          endReportTs: moment('2023-09-01T10:06:02.017'),
          feePayerName: 'Nela Soukupová',
          feePayerWasteCardCode: '123',
          wasteName: '',
          wasteColor: '#000000',
          weight: null,
          recordCount: 0,
          subRecords: null,
        },
        {
          id: 4,
          invoice: 'V230816001',
          fee: 0,
          feePaid: true,
          startReportTs: moment('2023-08-16T05:43:03.223'),
          endReportTs: moment('2023-08-16T05:43:03.223'),
          feePayerName: 'Nela Soukupová',
          feePayerWasteCardCode: '123',
          wasteName: '',
          wasteColor: '#000000',
          weight: 30,
          recordCount: 3,
          subRecords: [
            {
              startReportTs: moment('2023-08-16T07:44:24.713'),
              wasteName: 'Plasty',
              wasteColor: '#FFFF31',
              weight: 10,
              fee: 0,
            },
            {
              startReportTs: moment('2023-08-16T07:44:24.713'),
              wasteName: 'Papír a lepenka',
              wasteColor: '#008FF8',
              weight: 10,
              fee: 0,
            },
            {
              startReportTs: moment('2023-08-16T07:44:24.713'),
              wasteName: 'Sklo',
              wasteColor: '#2E7811',
              weight: 10,
              fee: 0,
            },
          ],
        },
        {
          id: 5,
          invoice: '2208030001',
          fee: null,
          feePaid: true,
          startReportTs: moment('2022-08-03T10:43:40.097'),
          endReportTs: moment('2022-08-03T10:43:40.097'),
          feePayerName: 'Nela Soukupová',
          feePayerWasteCardCode: '123',
          wasteName: 'Papír a lepenka',
          wasteColor: '#008FF8',
          weight: 50,
          recordCount: 1,
          subRecords: null,
        },
        {
          id: 6,
          invoice: '2208030001',
          fee: null,
          feePaid: true,
          startReportTs: moment('2022-08-03T10:34:31.03'),
          endReportTs: moment('2022-08-03T10:34:31.03'),
          feePayerName: 'Nela Soukupová',
          feePayerWasteCardCode: '123',
          wasteName: 'Papír a lepenka',
          wasteColor: '#008FF8',
          weight: 50,
          recordCount: 1,
          subRecords: null,
        },
        {
          id: 7,
          invoice: '2207270001',
          fee: 30172.275,
          feePaid: true,
          startReportTs: moment('2022-07-27T07:18:49.737'),
          endReportTs: moment('2022-07-27T07:18:49.737'),
          feePayerName: 'Nela Soukupová',
          feePayerWasteCardCode: '123',
          wasteName: '',
          wasteColor: '#000000',
          weight: 300,
          recordCount: 3,
          subRecords: [
            {
              startReportTs: moment('2022-07-27T09:18:49.807'),
              wasteName: 'Plasty',
              wasteColor: '#FFFF31',
              weight: 21.92,
              fee: 0,
            },
            {
              startReportTs: moment('2022-07-27T09:18:49.807'),
              wasteName: 'Papír a lepenka',
              wasteColor: '#008FF8',
              weight: 47.153,
              fee: 235.765,
            },
            {
              startReportTs: moment('2022-07-27T09:18:49.807'),
              wasteName: 'Sklo',
              wasteColor: '#2E7811',
              weight: 5000,
              fee: 24700,
            },
          ],
        },
        {
          id: 8,
          invoice: '2207270001',
          fee: null,
          feePaid: true,
          startReportTs: moment('2022-07-27T05:59:15.667'),
          endReportTs: moment('2022-07-27T05:59:15.667'),
          feePayerName: 'Nela Soukupová',
          feePayerWasteCardCode: '123',
          wasteName: '',
          wasteColor: '#000000',
          weight: null,
          recordCount: 0,
          subRecords: null,
        },
        {
          id: 9,
          invoice: '2207270001',
          fee: null,
          feePaid: true,
          startReportTs: moment('2022-07-27T05:19:39.957'),
          endReportTs: moment('2022-07-27T05:19:39.957'),
          feePayerName: 'Nela Soukupová',
          feePayerWasteCardCode: '123',
          wasteName: 'Papír a lepenka',
          wasteColor: '#008FF8',
          weight: 100,
          recordCount: 1,
          subRecords: null,
        },
        {
          id: 10,
          invoice: '2204280001',
          fee: null,
          feePaid: true,
          startReportTs: moment('2022-04-28T13:20:37.44'),
          endReportTs: moment('2022-04-28T13:20:37.44'),
          feePayerName: 'Nela Soukupová',
          feePayerWasteCardCode: '123',
          wasteName: '',
          wasteColor: '#000000',
          weight: null,
          recordCount: 0,
          subRecords: null,
        },
      ],
      pagination: {
        page: 1,
        pageCount: 1,
        limit: 10,
        total: 10,
      },
    },
    subject: {
      id: 1,
      name: 'Novákovi',
      streetAddress: 'Ostravská 123',
      municipalityName: 'Odpady Ostrava',
      postCode: '700 30',
      location: {
        latitude: 49.8339461,
        longitude: 18.2487258,
      },
      subjectType: 'Household',
      feePayerCount: 4,
      unsortableWasteWeight: 29.27,
      otherWasteWeight: 0,
      topWastes: [],
      sortRatio: null,
      otherSubjectsPercentil: 1,
    },
    feePayers: [
      {
        id: 1,
        firstName: 'Lukáš',
        lastName: 'Soukup',
        dateOfBirth: moment('1979-11-26T00:00:00'),
        phone: '',
        email: 'lukas@soukupovi.cz',
        wasteCard: '',
        fee: 200,
      },
      {
        id: 3,
        firstName: 'Nela',
        lastName: 'Soukupová',
        dateOfBirth: moment('1988-06-14T00:00:00'),
        phone: '',
        email: 'nela@soukupovi.cz',
        wasteCard: '',
        fee: 200,
      },
      {
        id: 9,
        firstName: 'Filip',
        lastName: 'Soukup',
        dateOfBirth: moment('2013-05-12T00:00:00'),
        phone: '',
        email: 'filip@soukupovi.cs',
        wasteCard: '',
        fee: 200,
      },
      {
        id: 27212,
        firstName: 'Josef',
        lastName: 'Soukup',
        dateOfBirth: moment('2014-05-12T00:00:00'),
        phone: '',
        email: 'josef@soukupovi.cz',
        wasteCard: '',
        fee: 200,
      },
    ],
    topTrashBins: [
      {
        id: 119892979,
        binName: 'Popelnice SKO',
        wasteName: 'Sko',
        wasteColor: '#191919',
        state: 'Used',
        barcode: 'WKCJKML.BBX',
        epc: '',
        totalWasteCollected: 3984894,
      },
      {
        id: 54892513462033,
        binName: 'Kontejner sklo bílé',
        wasteName: 'Sklo',
        wasteColor: '#2E7811',
        state: 'Used',
        barcode: 'WKCWKCVLNEN.BFK',
        epc: '',
        totalWasteCollected: 5999,
      },
      {
        id: 54892510934403,
        binName: 'Pytel papír (sled)',
        wasteName: 'Papír a lepenka',
        wasteColor: '#008FF8',
        state: 'Used',
        barcode: 'WKCWKCPXSBZ.BBT',
        epc: '',
        totalWasteCollected: 353,
      },
      {
        id: 54892510934404,
        binName: 'Pytel papír (sled)',
        wasteName: 'Papír a lepenka',
        wasteColor: '#008FF8',
        state: 'Used',
        barcode: 'WKCWKCPXSCA.BBT',
        epc: '',
        totalWasteCollected: 353,
      },
      {
        id: 119916262,
        binName: 'Pytel papír (sled)',
        wasteName: 'Papír a lepenka',
        wasteColor: '#008FF8',
        state: 'Used',
        barcode: 'WKCKSXY.BBT',
        epc: '',
        totalWasteCollected: 171.82,
      },
    ],
    trashBins: {
      items: [
        {
          id: 119892979,
          binName: 'Popelnice SKO',
          wasteName: 'Sko',
          wasteColor: '#191919',
          state: 'Used',
          barcode: 'WKCJKML.BBX.HB',
          epc: '',
          totalWasteCollected: 3984894,
        },
        {
          id: 54892513462033,
          binName: 'Kontejner sklo bílé',
          wasteName: 'Sklo',
          wasteColor: '#2E7811',
          state: 'Used',
          barcode: 'WKCWKCVLNEN.BFK.HEWQ',
          epc: '',
          totalWasteCollected: 5999,
        },
        {
          id: 54892510934403,
          binName: 'Pytel papír (sled)',
          wasteName: 'Papír a lepenka',
          wasteColor: '#008FF8',
          state: 'Used',
          barcode: 'WKCWKCPXSBZ.BBT.HB',
          epc: '',
          totalWasteCollected: 353,
        },
        {
          id: 54892510934404,
          binName: 'Pytel papír (sled)',
          wasteName: 'Papír a lepenka',
          wasteColor: '#008FF8',
          state: 'Used',
          barcode: 'WKCWKCPXSCA.BBT.HB',
          epc: '',
          totalWasteCollected: 353,
        },
        {
          id: 119916262,
          binName: 'Pytel papír (sled)',
          wasteName: 'Papír a lepenka',
          wasteColor: '#008FF8',
          state: 'Used',
          barcode: 'WKCKSXY.BBT',
          epc: '',
          totalWasteCollected: 171.82,
        },
        {
          id: 119927667,
          binName: 'Pytel papír (sled)',
          wasteName: 'Papír a lepenka',
          wasteColor: '#008FF8',
          state: 'Used',
          barcode: 'WKCLJUP.BBT.HB',
          epc: '',
          totalWasteCollected: 5,
        },
        {
          id: 119927668,
          binName: 'Pytel papír (sled)',
          wasteName: 'Papír a lepenka',
          wasteColor: '#008FF8',
          state: 'Used',
          barcode: 'WKCLJUQ.BBT.HB',
          epc: '',
          totalWasteCollected: 5,
        },
        {
          id: 119927669,
          binName: 'Pytel papír (sled)',
          wasteName: 'Papír a lepenka',
          wasteColor: '#008FF8',
          state: 'Used',
          barcode: 'WKCLJUR.BBT.HB',
          epc: '',
          totalWasteCollected: 5,
        },
        {
          id: 119927670,
          binName: 'Pytel papír (sled)',
          wasteName: 'Papír a lepenka',
          wasteColor: '#008FF8',
          state: 'Used',
          barcode: 'WKCLJUS.BBT.HB',
          epc: '',
          totalWasteCollected: 5,
        },
        {
          id: 54892510934402,
          binName: 'Pytel papír (sled)',
          wasteName: 'Papír a lepenka',
          wasteColor: '#008FF8',
          state: 'Used',
          barcode: 'WKCWKCPXSBY.BBT.HB',
          epc: '',
          totalWasteCollected: 2.5,
        },
      ],
      pagination: {
        page: 1,
        pageCount: 1,
        limit: 10,
        total: 10,
      },
    },
  }
}
